/**
 * @file     labels.ts
 * @purpose  Owner-facing address labels for the builder and dashboard. The
 *           owner sees their own full address ("Unit 3, 2846 West 6th
 *           Avenue"); renters never do. Empty when nothing is entered yet.
 */

type AddressLike = { streetNumber?: unknown; streetName?: unknown; unit?: unknown };

const text = (v: unknown) => (typeof v === 'string' ? v.trim() : '');

export function listingAddressLabel(address: Record<string, unknown> | null | undefined): string {
  const a = (address ?? {}) as AddressLike;
  const street = [text(a.streetNumber), text(a.streetName)].filter(Boolean).join(' ');
  if (!street) return '';
  return text(a.unit) ? `Unit ${text(a.unit)}, ${street}` : street;
}
